import { useT } from '../lib/i18n';

/** Request states stay distinct from an account with no content. */
export function RequestFeedback({ pending, failed, hasData = false, retry, retrying = false }: { pending: boolean; failed: boolean; hasData?: boolean; retry: () => void; retrying?: boolean }) {
  const { t } = useT();
  if (failed) return <div className="dashboard-feedback" role="alert"><span>{t(hasData ? 'dashboard.stale' : 'dashboard.loadFailed')}</span><button type="button" className="btn outline sm" disabled={retrying} onClick={retry}>{t(retrying ? 'common.loading' : 'common.retry')}</button></div>;
  if (pending && !hasData) return <div className="dashboard-loading" role="status" aria-label={t('common.loading')}><span /><span /><span /><p>{t('common.loading')}</p></div>;
  return null;
}
